export enum DealerQuotesTabsEnum {
  'Not Submitted' = 1,
  'Not Completed' = 5,
  'Completed',
  'All Quotes',
}
